/* Collection / search listing: faceted filters, sort, price range, grid/list toggle, mobile filter drawer and
   Section Rendering API updates (no full page reload). Works on top of server-rendered GET forms/links. */
(function () {
  'use strict';
  if (window.__plpListing) return;
  window.__plpListing = true;

  var VIEW_KEY = 'theme.plp.view';
  var REGIONS = ['side', 'drawer-body', 'drawer-actions', 'results', 'sheet'];
  var expanded = {};
  var requestId = 0;
  var controller = null;
  var lastTrigger = null;
  var debounceTimer = null;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function rootEl() { return qs('[data-plp-root]'); }
  function sectionId() { var r = rootEl(); return r ? r.getAttribute('data-section-id') : null; }

  /* ---------- view toggle (grid / list) ---------- */
  function getView() {
    try { return localStorage.getItem(VIEW_KEY) === 'list' ? 'list' : 'grid'; } catch (e) { return 'grid'; }
  }
  function applyView(view) {
    view = view || getView();
    var results = qs('[data-plp-region="results"]');
    if (!results) return;
    results.setAttribute('data-view', view);
    var grid = qs('[data-plp-grid]', results);
    var list = qs('[data-plp-list]', results);
    if (grid) grid.hidden = view !== 'grid';
    if (list) list.hidden = view !== 'list';
    qsa('[data-plp-view]', results).forEach(function (btn) {
      var on = btn.getAttribute('data-plp-view') === view;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---------- "Show more" on long filter groups ---------- */
  function initMore() {
    qsa('[data-plp-group][data-limit]').forEach(function (group) {
      if (group.getAttribute('data-more-init')) return;
      group.setAttribute('data-more-init', 'true');
      var limit = parseInt(group.getAttribute('data-limit'), 10) || 6;
      var items = qsa('[data-plp-item]', group);
      if (items.length <= limit) return;
      var heading = qs('h2', group);
      var key = heading ? heading.textContent : '';
      var open = !!expanded[key];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'link-btn filter-option__show-more';
      function paint() {
        items.forEach(function (item, i) {
          var active = item.classList.contains('is-on');
          item.hidden = !open && i >= limit && !active;
        });
        btn.textContent = open ? group.getAttribute('data-less') : group.getAttribute('data-more');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      btn.addEventListener('click', function () { open = !open; expanded[key] = open; paint(); });
      group.appendChild(btn);
      paint();
    });
  }

  function initAll() {
    applyView();
    initMore();
    if (window.__plpThemeFilters) window.__plpThemeFilters.init();
    if (window.Theme && Theme.wishlist) Theme.wishlist.sync();
  }

  /* ---------- URL building ---------- */
  function formToUrl(form, override) {
    var params = new URLSearchParams();
    var data = new FormData(form);
    var sortValue = null;
    data.forEach(function (value, name) {
      if (name === 'page' || name === 'section_id') return;
      if (name === 'sort_by') { return; }
      if (value === '' || value === null) return;
      params.append(name, value);
    });
    if (override && override.name === 'sort_by') {
      sortValue = override.value;
    } else {
      var select = qs('select[name="sort_by"]', form) || (form.elements && form.elements.sort_by);
      var checked = qs('input[name="sort_by"]:checked[form="' + form.id + '"]');
      if (select && select.value && select.tagName === 'SELECT') sortValue = select.value;
      else if (checked) sortValue = checked.value;
      else { var hidden = qs('input[type="hidden"][name="sort_by"]', form); if (hidden) sortValue = hidden.value; }
    }
    if (sortValue) params.set('sort_by', sortValue);
    var action = form.getAttribute('action') || window.location.pathname;
    var query = params.toString();
    return action + (query ? '?' + query : '');
  }

  /* ---------- Section Rendering API ---------- */
  function replaceRegions(doc) {
    var focusId = document.activeElement && document.activeElement.id;
    var ok = false;
    REGIONS.forEach(function (name) {
      var next = qs('[data-plp-region="' + name + '"]', doc);
      var current = qs('[data-plp-region="' + name + '"]');
      if (!next || !current) return;
      if (name === 'results') ok = true;
      if (name === 'sheet') next.hidden = true;
      current.parentNode.replaceChild(next, current);
    });
    if (ok) {
      initAll();
      if (focusId) { var again = document.getElementById(focusId); if (again && again.focus) { try { again.focus({ preventScroll: true }); } catch (e) { again.focus(); } } }
    }
    return ok;
  }

  function navigate(url, opts) {
    opts = opts || {};
    var id = sectionId();
    if (!id || !window.fetch || !window.DOMParser) { window.location.href = url; return; }
    var target = new URL(url, window.location.origin);
    var fetchUrl = new URL(target.href);
    fetchUrl.searchParams.set('section_id', id);
    var current = ++requestId;
    if (controller && controller.abort) controller.abort();
    controller = window.AbortController ? new AbortController() : null;
    var results = qs('[data-plp-region="results"]');
    if (results) results.setAttribute('aria-busy', 'true');
    qsa('[data-plp-form]').forEach(function (f) { f.setAttribute('aria-busy', 'true'); });

    fetch(fetchUrl.pathname + fetchUrl.search, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal: controller ? controller.signal : undefined })
      .then(function (res) { if (!res.ok) throw new Error('bad response'); return res.text(); })
      .then(function (html) {
        if (current !== requestId) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (!replaceRegions(doc)) { window.location.href = target.href; return; }
        if (opts.push !== false) window.history.pushState({ plp: true }, '', target.pathname + target.search);
        if (opts.scroll) {
          var r = qs('[data-plp-region="results"]');
          if (r && r.scrollIntoView) r.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        document.dispatchEvent(new CustomEvent('theme:listing:updated', { detail: { url: target.href } }));
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = target.href;
      });
  }

  /* ---------- drawer / sort sheet ---------- */
  function openLayer(name, trigger) {
    var layer = qs('[data-plp-drawer="' + name + '"]');
    if (!layer) return;
    closeLayers(true);
    lastTrigger = trigger || null;
    layer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var dialog = qs('[role="dialog"]', layer);
    if (dialog) dialog.focus();
  }
  function closeLayers(silent) {
    var any = false;
    qsa('[data-plp-drawer]').forEach(function (layer) {
      if (!layer.hidden) { layer.hidden = true; any = true; }
    });
    qsa('[data-plp-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.documentElement.style.overflow = '';
    if (any && !silent && lastTrigger && lastTrigger.focus) { try { lastTrigger.focus(); } catch (e) { /* trigger removed */ } }
  }

  /* ---------- events ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.matches('[data-plp-sort]')) {
      var sortForm = t.form || qs('[data-plp-sort-form]');
      if (!sortForm) return;
      closeLayers(true);
      navigate(formToUrl(sortForm, { name: 'sort_by', value: t.value }), { push: true });
      return;
    }

    var form = t.closest('[data-plp-form]');
    if (!form) return;
    if (t.type === 'checkbox') {
      var label = t.closest('[data-plp-item]');
      if (label) {
        label.classList.toggle('is-on', t.checked);
        var box = qs('.plp-box', label);
        if (box) box.classList.toggle('is-on', t.checked);
      }
    }
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(function () { navigate(formToUrl(form)); }, 250);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !(form.matches('[data-plp-form]') || form.matches('[data-plp-sort-form]'))) return;
    e.preventDefault();
    window.clearTimeout(debounceTimer);
    navigate(formToUrl(form));
  });

  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target : null;
    if (!el) return;

    var link = el.closest('a[data-plp-link]');
    if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && e.button === 0) {
      e.preventDefault();
      var inPager = !!link.closest('[data-plp-pagination]');
      navigate(link.href, { scroll: inPager });
      return;
    }

    var viewBtn = el.closest('[data-plp-view]');
    if (viewBtn) {
      var view = viewBtn.getAttribute('data-plp-view');
      try { localStorage.setItem(VIEW_KEY, view); } catch (err) { /* storage unavailable */ }
      applyView(view);
      return;
    }

    var opener = el.closest('[data-plp-open]');
    if (opener) { openLayer(opener.getAttribute('data-plp-open'), opener); return; }

    if (el.closest('[data-plp-close]')) { closeLayers(); }
  });

  document.addEventListener('keydown', function (e) {
    var open = qsa('[data-plp-drawer]').filter(function (l) { return !l.hidden; })[0];
    if (!open) return;
    if (e.key === 'Escape') { e.preventDefault(); closeLayers(); return; }
    if (e.key !== 'Tab') return;
    var focusables = qsa('a[href], button:not([disabled]), input:not([disabled]):not(.sr), select, [tabindex="0"]', open)
      .filter(function (n) { return n.offsetParent !== null; });
    var dialog = qs('[role="dialog"]', open);
    if (!focusables.length) { e.preventDefault(); if (dialog) dialog.focus(); return; }
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  window.addEventListener('popstate', function () {
    if (rootEl()) navigate(window.location.href, { push: false });
  });

  /* ---------- Theme filters (no app needed) ----------
     Used when plp-theme-filters.liquid is rendered. The filter groups are built from the data-filter-* attributes
     of the product cards on the page (vendor, type, price in minor units, availability, tags, options) and cards are
     shown/hidden instantly. Groups combine with AND, values inside a group with OR; counts are faceted. */
  window.__plpThemeFilters = (function () {
    var LIMIT = 6;
    var state = fresh();
    var products = [];
    var more = {};
    var i18n = null;
    var buckets = [];
    var symbol = '$';
    var focusKey = null;
    var focusIndex = 0;
    var config = {};

    function fresh() { return { avail: {}, vendor: {}, type: {}, tags: {}, opts: {}, min: null, max: null }; }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function keys(o) { return Object.keys(o).filter(function (k) { return o[k]; }); }
    function money(cents) { return window.Theme && Theme.money ? Theme.money(cents) : String(cents / 100); }
    function containers() { return qsa('[data-theme-filters]'); }

    function readConfig(el) {
      try { i18n = JSON.parse(el.getAttribute('data-i18n')); } catch (e) { i18n = null; }
      try { config = JSON.parse(el.getAttribute('data-config')) || {}; } catch (e) { config = {}; }
      symbol = el.getAttribute('data-symbol') || '$';
      buckets = (el.getAttribute('data-buckets') || '').split(/\n|<br\s*\/?>/).join('|').split('|').map(function (line) {
        var p = line.trim().split('-');
        if (p.length !== 2) return null;
        var min = p[0].trim() === '' ? 0 : parseFloat(p[0]);
        var max = p[1].trim() === '' ? null : parseFloat(p[1]);
        if (isNaN(min) || (max !== null && isNaN(max))) return null;
        return { min: min, max: max };
      }).filter(Boolean);
    }

    function parseCards() {
      products = [];
      qsa('[data-plp-grid] [data-product-card]').forEach(function (card) {
        var handle = card.getAttribute('data-product-handle');
        var listCard = qs('[data-plp-list] [data-product-handle="' + handle + '"]');
        var els = [card.closest('li'), listCard ? listCard.closest('li') : null].filter(Boolean);
        var opts = {};
        (card.getAttribute('data-filter-options') || '').split('||').forEach(function (pair) {
          if (!pair) return;
          var i = pair.indexOf('::');
          if (i < 0) return;
          opts[pair.slice(0, i)] = pair.slice(i + 2).split('~~').filter(Boolean);
        });
        products.push({
          els: els,
          vendor: card.getAttribute('data-filter-vendor') || '',
          type: card.getAttribute('data-filter-type') || '',
          price: parseInt(card.getAttribute('data-filter-price'), 10) || 0,
          avail: card.getAttribute('data-filter-available') === 'true',
          tags: (card.getAttribute('data-filter-tags') || '').split('||').filter(Boolean),
          opts: opts
        });
      });
    }

    function matches(p, skip) {
      var a = keys(state.avail);
      if (skip !== 'avail' && a.length && !((a.indexOf('in') > -1 && p.avail) || (a.indexOf('out') > -1 && !p.avail))) return false;
      if (skip !== 'price') {
        if (state.min !== null && p.price < state.min * 100) return false;
        if (state.max !== null && p.price > state.max * 100) return false;
      }
      var v = keys(state.vendor);
      if (skip !== 'vendor' && v.length && v.indexOf(p.vendor) < 0) return false;
      var t = keys(state.type);
      if (skip !== 'type' && t.length && t.indexOf(p.type) < 0) return false;
      var g = keys(state.tags);
      if (skip !== 'tags' && g.length && !g.some(function (x) { return p.tags.indexOf(x) > -1; })) return false;
      var names = Object.keys(state.opts);
      for (var i = 0; i < names.length; i++) {
        var sel = keys(state.opts[names[i]]);
        if (skip !== 'opt:' + names[i] && sel.length && !sel.some(function (x) { return (p.opts[names[i]] || []).indexOf(x) > -1; })) return false;
      }
      return true;
    }

    function tally(skip, getValues) {
      var counts = {};
      products.forEach(function (p) {
        getValues(p).forEach(function (val) { if (!(val in counts)) counts[val] = 0; });
        if (matches(p, skip)) getValues(p).forEach(function (val) { counts[val] += 1; });
      });
      return counts;
    }

    function sortedValues(counts, selected) {
      return Object.keys(counts).sort(function (a, b) {
        var sa = selected[a] ? 1 : 0, sb = selected[b] ? 1 : 0;
        if (sa !== sb) return sb - sa;
        if (counts[b] !== counts[a]) return counts[b] - counts[a];
        return a.localeCompare(b);
      });
    }

    var CHECK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"></path></svg>';

    function checkbox(group, value, label, count, on) {
      var disabled = count === 0 && !on;
      var key = group + '|' + value;
      return '<label class="frow plp-row' + (on ? ' is-on' : '') + (disabled ? ' is-disabled' : '') + '" data-plp-item>' +
        '<input class="sr" type="checkbox" data-tf-group="' + esc(group) + '" data-tf-value="' + esc(value) + '" data-tf-key="' + esc(key) + '"' + (on ? ' checked' : '') + (disabled ? ' disabled' : '') + '>' +
        '<span class="plp-box' + (on ? ' is-on' : '') + '">' + CHECK + '</span>' + esc(label) +
        '<span class="filter-option__count">' + count + '</span></label>';
    }

    function section(first, title, body, id) {
      return '<section class="fsec ' + (first ? 'filters-sidebar__section-first' : 'filters-sidebar__section') + '"><h2 class="filters-sidebar__heading">' + esc(title) + '</h2>' + body + '</section>';
    }

    function listGroup(first, title, group, counts, selected, labelFn) {
      var vals = sortedValues(counts, selected);
      if (!vals.length) return '';
      var open = !!more[group];
      var html = '<div class="flex-column-gap-2" role="group">';
      vals.forEach(function (val, i) {
        if (i >= LIMIT && !open && !selected[val]) return;
        html += checkbox(group, val, labelFn ? labelFn(val) : val, counts[val], !!selected[val]);
      });
      html += '</div>';
      if (vals.length > LIMIT) html += '<button type="button" class="link-btn filter-option__show-more" data-tf-more="' + esc(group) + '" aria-expanded="' + open + '">' + esc(open ? i18n.showLess : i18n.showMore) + '</button>';
      return section(first, title, html);
    }

    function priceLabel(b) {
      var f = function (n) { return money(Math.round(n * 100)).replace(/([.,]00)(?=\D*$)/, ''); };
      if (b.max === null) return i18n.andUp.replace('__PRICE__', f(b.min));
      if (!b.min) return i18n.under.replace('__PRICE__', f(b.max));
      return f(b.min) + ' – ' + f(b.max);
    }

    function allowed(list, value) {
      if (!list || !list.length) return true;
      return list.some(function (x) { return String(x).trim().toLowerCase() === String(value).trim().toLowerCase(); });
    }

    function build(first) {
      var cfg = config || {};
      var show = cfg.show || {};
      var html = '';
      var firstFlag = first;
      function add(chunk) { if (chunk) { html += chunk; firstFlag = false; } }
      function on(key) { return show[key] !== false; }

      var makers = {
        availability: function () {
          var hasIn = products.some(function (p) { return p.avail; });
          var hasOut = products.some(function (p) { return !p.avail; });
          if (!(hasIn && hasOut)) return '';
          var ac = { in: 0, out: 0 };
          products.forEach(function (p) { if (matches(p, 'avail')) ac[p.avail ? 'in' : 'out'] += 1; });
          return section(firstFlag, i18n.availability, '<div class="flex-column-gap-2" role="group">' +
            checkbox('avail', 'in', i18n.inStock, ac.in, !!state.avail.in) + checkbox('avail', 'out', i18n.outOfStock, ac.out, !!state.avail.out) + '</div>');
        },
        price: function () {
          if (!products.length) return '';
          var maxPrice = Math.ceil(Math.max.apply(null, products.map(function (p) { return p.price; })) / 100);
          var body = '';
          if (buckets.length) {
            body += '<div class="flex-column-gap-2" role="radiogroup">';
            buckets.forEach(function (b, i) {
              var isOn = state.min === b.min && state.max === b.max;
              body += '<button type="button" role="radio" aria-checked="' + isOn + '" class="frow plp-row' + (isOn ? ' is-on' : '') + '" data-tf-bucket="' + i + '" data-tf-key="bucket|' + i + '"><span class="plp-radio' + (isOn ? ' is-on' : '') + '"></span>' + esc(priceLabel(b)) + '</button>';
            });
            body += '</div>';
          }
          body += '<div class="price-filter" role="group">' +
            '<label class="price-filter__field">' + esc(i18n.min) + '<span class="price-in price-filter__input-wrap"><span class="price-filter__currency">' + esc(symbol) + '</span><input class="price-filter__input" type="number" inputmode="decimal" min="0" data-tf-price="min" data-tf-key="price|min" placeholder="0" value="' + (state.min === null ? '' : state.min) + '"></span></label>' +
            '<span class="price-filter__dash" aria-hidden="true">\u2013</span>' +
            '<label class="price-filter__field">' + esc(i18n.max) + '<span class="price-in price-filter__input-wrap"><span class="price-filter__currency">' + esc(symbol) + '</span><input class="price-filter__input" type="number" inputmode="decimal" min="0" data-tf-price="max" data-tf-key="price|max" placeholder="' + maxPrice + '" value="' + (state.max === null ? '' : state.max) + '"></span></label></div>';
          return section(firstFlag, i18n.price, body);
        },
        brand: function () {
          var vendors = tally('vendor', function (p) { return p.vendor ? [p.vendor] : []; });
          return Object.keys(vendors).length > 1 ? listGroup(firstFlag, i18n.brand, 'vendor', vendors, state.vendor) : '';
        },
        type: function () {
          var types = tally('type', function (p) { return p.type ? [p.type] : []; });
          return Object.keys(types).length > 1 ? listGroup(firstFlag, i18n.type, 'type', types, state.type) : '';
        },
        options: function () {
          var names = [], out = '';
          products.forEach(function (p) { Object.keys(p.opts).forEach(function (n) { if (names.indexOf(n) < 0) names.push(n); }); });
          names.forEach(function (name) {
            if (!allowed(cfg.optionsAllow, name)) return;
            var sel = state.opts[name] || {};
            var counts = tally('opt:' + name, function (p) { return p.opts[name] || []; });
            if (Object.keys(counts).length > 1 || keys(sel).length) {
              var chunk = listGroup(firstFlag, name, 'opt:' + name, counts, sel);
              if (chunk) { out += chunk; firstFlag = false; }
            }
          });
          return out;
        },
        tags: function () {
          var tags = tally('tags', function (p) { return p.tags.filter(function (t) { return allowed(cfg.tagsAllow, t); }); });
          return Object.keys(tags).length > 1 ? listGroup(firstFlag, i18n.tags, 'tags', tags, state.tags) : '';
        }
      };

      var order = (cfg.order || []).map(function (x) { return String(x).trim().toLowerCase(); }).filter(function (x) { return makers[x]; });
      Object.keys(makers).forEach(function (k) { if (order.indexOf(k) < 0) order.push(k); });
      order.forEach(function (k, i) { if (order.indexOf(k) === i && on(k)) add(makers[k]()); });
      return html;
    }

    function render() {
      if (!i18n) return;
      containers().forEach(function (c) {
        var target = qs('[data-theme-filter-groups]', c);
        if (!target) return;
        target.innerHTML = build(target.getAttribute('data-first') === 'true');
      });
      if (focusKey) {
        var scope = containers()[focusIndex] || document;
        var again = qs('[data-tf-key="' + focusKey.replace(/"/g, '\\"') + '"]', scope);
        if (again && again.focus) { try { again.focus({ preventScroll: true }); } catch (e) { again.focus(); } }
        focusKey = null;
      }
    }

    function activeCount() {
      var n = keys(state.avail).length + keys(state.vendor).length + keys(state.type).length + keys(state.tags).length;
      Object.keys(state.opts).forEach(function (k) { n += keys(state.opts[k]).length; });
      if (state.min !== null || state.max !== null) n += 1;
      return n;
    }

    function apply() {
      var shown = 0;
      products.forEach(function (p) {
        var ok = matches(p, null);
        if (ok) shown += 1;
        p.els.forEach(function (el) { el.hidden = !ok; });
      });
      var filtered = activeCount() > 0;
      var counter = qs('[data-plp-count]');
      if (counter && i18n) {
        if (filtered) counter.textContent = shown === 0 ? i18n.countZero : (shown === 1 ? i18n.countOne.replace('1', shown) : i18n.countOther.replace('2', shown));
        else if (counter.hasAttribute('data-orig')) counter.textContent = counter.getAttribute('data-orig');
      }
      qsa('[data-theme-empty]').forEach(function (el) { el.hidden = !(filtered && shown === 0); });
      qsa('[data-theme-apply]').forEach(function (el) { if (i18n) el.textContent = i18n.showResults.replace('__COUNT__', shown); });
      qsa('[data-theme-clear]').forEach(function (el) { el.style.visibility = (filtered || el.closest('[data-theme-empty]')) ? '' : 'hidden'; });
    }

    function update() { render(); apply(); }

    function init() {
      var list = containers();
      if (!list.length) return;
      readConfig(list[0]);
      var counter = qs('[data-plp-count]');
      if (counter && !counter.hasAttribute('data-orig')) counter.setAttribute('data-orig', counter.textContent);
      parseCards();
      update();
    }

    /* ---- events ---- */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('[data-theme-filters]')) return;
      if (t.hasAttribute('data-tf-group')) {
        var g = t.getAttribute('data-tf-group'), v = t.getAttribute('data-tf-value');
        var bag;
        if (g.indexOf('opt:') === 0) { var n = g.slice(4); state.opts[n] = state.opts[n] || {}; bag = state.opts[n]; }
        else bag = state[g];
        bag[v] = t.checked;
        focusKey = t.getAttribute('data-tf-key');
        focusIndex = Math.max(0, containers().indexOf(t.closest('[data-theme-filters]')));
        update();
      } else if (t.hasAttribute('data-tf-price')) {
        var num = t.value === '' ? null : Math.max(0, parseFloat(t.value));
        state[t.getAttribute('data-tf-price')] = (num === null || isNaN(num)) ? null : num;
        focusKey = t.getAttribute('data-tf-key');
        focusIndex = Math.max(0, containers().indexOf(t.closest('[data-theme-filters]')));
        update();
      }
    });

    document.addEventListener('click', function (e) {
      var el = e.target.closest ? e.target : null;
      if (!el) return;
      var b = el.closest('[data-tf-bucket]');
      if (b) {
        var bucket = buckets[parseInt(b.getAttribute('data-tf-bucket'), 10)];
        if (!bucket) return;
        var on = state.min === bucket.min && state.max === bucket.max;
        state.min = on ? null : bucket.min;
        state.max = on ? null : bucket.max;
        focusKey = b.getAttribute('data-tf-key');
        focusIndex = Math.max(0, containers().indexOf(b.closest('[data-theme-filters]')));
        update();
        return;
      }
      var m = el.closest('[data-tf-more]');
      if (m) { var k = m.getAttribute('data-tf-more'); more[k] = !more[k]; focusKey = null; update(); return; }
      if (el.closest('[data-theme-clear]')) { state = fresh(); update(); }
    });

    return { init: init };
  })();

  document.addEventListener('shopify:section:load', function () { initAll(); });

  initAll();

  /* Price quick options (radio rows above Min/Max): fill the range inputs and let the form update the results. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-price-bucket]') : null;
    if (!b) return;
    var form = b.closest('[data-plp-form]');
    if (!form) return;
    var min = form.querySelector('input[name$=".gte"]'), max = form.querySelector('input[name$=".lte"]');
    if (!min || !max) return;
    var on = b.getAttribute('aria-checked') === 'true';
    min.value = on ? '' : b.getAttribute('data-min');
    max.value = on ? '' : b.getAttribute('data-max');
    min.dispatchEvent(new Event('change', { bubbles: true }));
  });

})();
